module.exports = __webpack_public_path__ + "static/media/couv.7ced5f77.jpg";